<template>
	<div>


		<div class="actions-panel" v-bind:class="panel_state">
			<a href="#" class="app-shadow actions-panel-toggle-btn" @click.prevent="togglePanel"><span class="fas" v-bind:class="'fa-chevron-' + toggle_btn_class"></span></a>
			<div class="app-shadow actions-panel-body">


				<div class="main-panel" v-bind:class="{ active: side_panel == 'main' }">

					<div @click="showForecast" style="cursor: pointer">
						<ForecastLine />
					</div>

					<button class="btn btn-secondary form-control mb-3" @click="musterAction"> <i class="fas fa-exclamation-triangle mr-1"></i> <strong>EMERGENCY MUSTERING</strong></button>

					<div class="border mb-3">
						<h5 class="mb-0 p-2">
							Zones
							<a data-toggle="collapse" href="#section-zone">
								<i class="fas border p-1 ml-3" v-bind:class="{ 'fa-chevron-up': !section_toggle.zone, 'fa-chevron-down': section_toggle.zone}"></i>
							</a>
						</h5>

						<div class='section collapse' id="section-zone">
							<ul class="list-group list-striped list-hover" >
								<li v-for="zone in zones" v-bind:key='zone.id' class='list-group-item zone-item d-flex justify-content-between align-items-center' v-bind:class="{ selected: selected_zone == zone.id}" style="cursor: pointer" @click="selectZone(zone.id)"  v-bind:style="{ color: zone.color }" >
									{{ zone.name }}
									<div class="zone-action-btns" v-bind:class="{ 'd-none': selected_zone != zone.id  }">
										<button class="btn" @click="focusZone(zone.id)">Focus</button>
										<button class="btn" @click="highlightZone(zone.id)">Highlight</button>
									</div>
								</li>
							</ul>
						</div>
					</div>

					<div class="border mt-3">
						<h5 @click="toggleSection('events')" class="mb-0 p-2">
							Events
							<a data-toggle="collapse" href="#section-events">
								<i class="fas border p-1 ml-2" v-bind:class="{ 'fa-chevron-up': !section_toggle.events, 'fa-chevron-down': section_toggle.events}"></i>
							</a>
						</h5>

						<div class="section collapse" id="section-events" >
							<ul class="list-group list-striped list-hover event-listing"  >
								<li class='list-group-item d-flex justify-content-between align-items-center' @click.stop.prevent="showEvents('fall')">

										Fall Detection
										<span v-if="Object.keys($finder.all({type: 'fall'}, alert)).length" class="badge text-danger">{{ Object.keys($finder.all({type: 'fall'}, alert)).length }} Alerts</span>


								</li>
								<li class='list-group-item d-flex justify-content-between align-items-center' @click.stop.prevent="showEvents('entry')">

										Restricted Area Entry
										<span v-if="Object.keys($finder.all({type: 'entry'}, alert)).length" class="badge text-danger">{{ Object.keys($finder.all({type: 'entry'}, alert)).length }} Alerts</span>

								</li>
								<li class='list-group-item d-flex justify-content-between align-items-center' @click.stop.prevent="showEvents('man-down')">

										Man Down
										<span v-if="Object.keys($finder.all({type: 'man-down'}, alert)).length" class="badge text-danger">{{ Object.keys($finder.all({type: 'man-down'}, alert)).length }} Alerts</span>

								</li>
							</ul>
						</div>
					</div>
				</div>


				<div class="alert-panel" v-bind:class="{ active: side_panel == 'alert' }" >
					<a href="#" @click.stop.prevent="switchPanel('main')" class="btn btn-light border border-dark panel-close-btn">Back to List</a>
					<div class="alert alert-info" v-if="Object.keys($finder.all({type: event_type}, alert)).length <= 0">No events to report.</div>
					<transition-group name="fade">
						<div class="p-3 alert-item" v-bind:class="{ selected: selected_alert == key}" v-for="(rec, key) in $finder.all({type: event_type}, alert)" @click.stop="toggleAlertSelection(key)" v-bind:key="key +0">
							Asset tag {{ rec.worker.first_name }} {{rec.worker.last_name}} {{rec.label}} "{{$finder.get('id='+rec.zone_id, zones).name}}" at {{rec.clock}}
							<div class="alert-item-btns" v-bind:class="{ 'd-none': selected_alert != key  }">
								<button class="btn" @click.stop="$refs.EventReport.showModal(key)">Report</button>
								<button class="btn" @click.stop="$refs.EventResolve.showModal(key)">Resolve</button>
							</div>
						</div>
					</transition-group>

				</div>

				<MusterPanel v-if="Object.keys(workers).length"/>

				<div class="weather-panel" :class="{ active: side_panel == 'forecast' }">
					<a href="#" @click.prevent="side_panel = 'main'" class="btn btn-light border border-dark panel-close-btn">
						Back to List
					</a>
					<ForecastComplete />
				</div>


			</div>
		</div>

		<EventReport ref="EventReport"/>
		<EventResolve ref="EventResolve"/>


	</div>
</template>

<script>

	import * as turf from '@turf/turf';
	import {mapState} from 'vuex'
	import EventReport from './Actions/EventReport.vue';
	import EventResolve from './Actions/EventResolve.vue';
	import MusterPanel from './Actions/MusterPanel.vue';
	import * as workerTimers from 'worker-timers';
	import ForecastLine from '../Views/Weather/ForecastLine'
	import ForecastComplete from '../Views/Weather/ForecastComplete'


	export default {
		name: 'ActionsPanel',
		components: {EventReport, EventResolve, MusterPanel, ForecastLine, ForecastComplete},
		props: {
			onToggleOpen: Function,
			isOpened: Boolean
		},
		data() {
			return {
				event_type: null,
				selected_alert: null,
				selected_zone: null,
				map_to: null,
				section_toggle: {'zone': true, 'events': true},
				modal: false
			}
		},
		watch: {
			alert() {
				if (Object.keys(this.$finder.all({type: this.event_type}, this.alert)).length == 0 && this.active_panel == 'alert-panel') {
					this.active_panel = 'main-panel';
					this.event_type = null;
				}
			},

		},
		computed: {
			panel_state() {
				const {isOpened} = this;
				return isOpened ? 'open' : 'collapsed'
			},
			toggle_btn_class() {
				const {isOpened} = this;
				return isOpened ? 'right' : 'left'
			},
			worker_types() {
				return this.$config.worker_types
			},
			alert: {
				get() {
					return this.$finder.all({'status': 'pending'}, this.$store.state.alert)
				},
				set(value) {
					this.$store.commit('add_alert', value)
				}
			},
			log: {
				get() {
					return this.$store.state.log
				},
				set(value) {
					this.$store.commit('add_log', value)
				}
			},
			zones() {
				let zones = {};
				for (let i in this.$store.state.zones) {
					let zone = this.$store.state.zones[i]
					if (zone.type == 'start' || zone.type == 'stairs' || zone.type == 'travel') continue;
					zones[zone.id] = {
						name: zone.name,
						id: zone.id,
						type: zone.type,
						color: this.$config['zone_types'][zone.type].color.replace(/[\d\.]+\)$/g, '1)')
					}
				}
				return zones;
			},
			muster: {
				get() {
					return this.$store.state.muster
				},
				set(value) {
					this.$store.commit('setState', ['muster', value])
				}
			},
			side_panel: {
				get() { return this.$store.state.side_panel },
				set(value) { this.$store.commit('setState', ['side_panel', value])}
			},
			floor_level: {
				get () {
					return this.$store.state.floor_level
				},
				set (value) {
					this.$store.commit('setState', ['floor_level', value])
				}
			},
			map() {
				return this.$store.state.map.map
			},
			styles() {
				return this.$store.state.styles
			},
			side_panel_open: {
				get() { return this.$store.state.side_panel_open},
				set(value) { this.$store.commit('setState', ['side_panel_open', value])}
			},
			...mapState([
				'workers',
				'watcher',
				'features',
				'day',
				'time',
				'weather',
				'location'
			])
		},
		mounted() {
			this.init();
			$('.section').each(function () {
				$(this).css('max-height', $(this).height());
			})
		},
		methods: {
			init() {
				let that = this;
				$('body').on('click', function (e) {
					that.selected_alert = null;
				});
			},
			togglePanel() {

				this.$emit('onToggleOpen')
				this.side_panel_open = !this.side_panel_open;
			},
			switchPanel(panel) {
				this.side_panel = panel;
			},
			musterAction() {

				this.side_panel = 'muster';

				if (this.muster) return;

				let event_id = this.$finder.next_id(this.log);
				this.muster = event_id;
				let event = {type: 'muster', time: this.time, id: event_id, status: 'active', day: this.day, end: null};
				this.$set(this.log, event_id, event);

			},
			showForecast() {
				this.side_panel = 'forecast';
			},
			showEvents(type) {
				this.side_panel = 'alert';
				this.event_type = type;
			},
			toggleAlertSelection(key) {
				if (this.selected_alert == key) this.selected_alert = null;
				else this.selected_alert = key;
			},
			selectZone(id) {
				this.selected_zone = id;
			},
			highlightZone(id) {
				let feature = this.features[id];
				this.floor_level = feature.floor_level;

				var that = this;
				workerTimers.setTimeout(function () {
					feature.setStyle(
						new ol.style.Style({
							stroke: new ol.style.Stroke({color: 'rgba(255,255,255,1)', width: 2}),
							fill: new ol.style.Fill({color: that.zones[id].color})
						})
					)
				}, 20);

				workerTimers.setTimeout(function () {
					feature.setStyle();
				}, 5000);
			},
			focusZone(id) {
				let feature = this.features[id];
				let zone = this.zones[id];

				this.floor_level = feature.floor_level;

				let center = this.map.getView().getCenter();
				if (zone.tool == 'Circle') {
					center = zone.center;
				}
				else {
					center = turf.centerOfMass(feature.turf).geometry.coordinates;
					center = ol.proj.transform(center, 'EPSG:4326', 'EPSG:3857');
				}

				this.map.getView().animate({
					center: center,
					duration: 1000
				});
				this.map.getView().fit(feature.getGeometry(), {duration: 1000});

			},
			toggleSection(section) {
				this.section_toggle[section] = !this.section_toggle[section];
			}
		}
	}
</script>
